$(document).ready(function(){
  //show/hide backordered qty based on current stock on cart
  $('.tt-input-counter').find('input').change(function(){
      var selected_qty = $(this).val();
      var parent = $(this).parents('tr');
      var available_qty = parent.find('.tt-backorder_qua').data('current-qty');

      if(selected_qty > available_qty){
        parent.find('.tt-backorder_qua').html('* Qty: '+(selected_qty - (available_qty >= 0 ? available_qty : 0) )+' is Backordered');
      }else{
        parent.find('.tt-backorder_qua').html('');
      }
  });

  function enableFocusToggle(options = {}) {
    const {
      selector,
      focusClass,
      blurOnEscape = true
    } = options;

    const focusSelectors = document.querySelectorAll(selector);

    function handleFocus() {
      document.body.classList.add(focusClass);
    }

    function handleBlur() {
      document.body.classList.remove(focusClass);
    }

    focusSelectors.forEach(input => {
      input.addEventListener('focus', handleFocus);
      input.addEventListener('blur', handleBlur);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.body.classList.remove(focusClass);
        if (blurOnEscape) {
          const focusedInput = document.querySelector(`${selector}:focus`);
          if (focusedInput) {
            focusedInput.blur();
          }
        }
      }
    });
  }

  enableFocusToggle({
    selector: 'input.tt-search-input',
    focusClass: 'search-focused',
    blurOnEscape: true
  });

  // enableFocusToggle({
  //   selector: '.tt-cart button',
  //   focusClass: 'cart-focused',
  //   blurOnEscape: true
  // });

  function enableVisibilityToggle({ selector, activeClass, bodyClass }) {
    const target = document.querySelector(selector);
    if (!target) return;

    // Initial check in case it's already active
    if (target.classList.contains(activeClass)) {
      document.body.classList.add(bodyClass);
    }

    // Observe class changes
    const observer = new MutationObserver(() => {
      if (target.classList.contains(activeClass)) {
        document.body.classList.add(bodyClass);
      } else {
        document.body.classList.remove(bodyClass);
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Example usage
  enableVisibilityToggle({
    selector: '.tt-cart.tt-dropdown-obj',
    activeClass: 'active',
    bodyClass: 'cart-focused'
  });

  document.addEventListener('click', function (e) {
    const pillTrigger = e.target.closest('.tt-category-pills .pill.has-children');

    // Pills with children toggle their "Narrow It" row instead of navigating —
    // the row's "All" link is what actually reaches the pill's own collection.
    if (pillTrigger) {
      e.preventDefault();

      const key = pillTrigger.getAttribute('data-pill-toggle');
      const narrowIt = document.querySelector('.narrow-it[data-narrow-it="' + key + '"]');
      const willOpen = !pillTrigger.classList.contains('open');

      document.querySelectorAll('.tt-category-pills .pill.open').forEach(function (other) {
        if (other !== pillTrigger) {
          other.classList.remove('open');
          other.classList.remove('active');
        }
      });
      document.querySelectorAll('.narrow-it.open').forEach(function (other) {
        if (other !== narrowIt) other.classList.remove('open');
      });

      pillTrigger.classList.toggle('open', willOpen);
      pillTrigger.classList.toggle('active', willOpen);
      if (narrowIt) narrowIt.classList.toggle('open', willOpen);
    }
  });

  // Double-clicking the already-active pill (single click only toggles its
  // Narrow It row) navigates to that pill's own collection, same destination as "All".
  document.addEventListener('dblclick', function (e) {
    const pillTrigger = e.target.closest('.tt-category-pills .pill.has-children.active');

    if (pillTrigger) {
      window.location.href = pillTrigger.getAttribute('href');
    }
  });

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.mm-dropdown > a.toggle-submenu');

    // Only act if clicked inside a .mm-dropdown anchor
    if (trigger) {
      e.preventDefault();

      const dropdown = trigger.parentElement;
      const submenu = dropdown.querySelector('ul');

      if (submenu) {
        // Toggle current dropdown
        dropdown.classList.toggle('open');

        // Optional: close others (accordion effect)
        document.querySelectorAll('.mm-dropdown.open').forEach(other => {
          if (other !== dropdown) other.classList.remove('open');
        });
      }
    }
  });


});

/* ============================================================================
   WCP rail mega menu — hover behavior  (BLUE store)   v5  (2026-10-07)

   PASTE: replace the existing WCP block at the BOTTOM of assets/custom-script.js
   (from this header comment to its closing  })();  ) with this file. The theme's
   own code above it stays. The file is loaded in <head> without defer, so nothing
   here may read <body> before boot().
   This file boots itself and needs no jQuery.

   THE TWO RULES EVERYTHING ELSE FOLLOWS FROM
     1. WE own display. Wokiee opens the panel itself on CSS :hover, so anything
        that tries to time the open/close is fighting a stylesheet it can't see.
        display is set inline + !important, which no stylesheet can beat — and is
        RELEASED again on touch devices / mobile, where inline !important would
        otherwise pin the menu shut forever.
     2. What is shown is always what is hovered. A queued swap is cancelled the
        moment the pointer leaves what queued it, the commit re-reads what is
        hovered at that instant, and assertOne() forces exactly one panel once a
        transition ends. No sequence of moves may ever show two at once.

   Safe triangle: the apex sits ~90ms behind the cursor (not one sample, which put
   it ~2px away and made every twitch read as "travelling"), needs real travel to
   trigger, and is re-checked on every move so it commits the instant you stop.

   v4 — THREE RULES THAT MAKE IT UNBREAKABLE AT ANY SPEED
     3. "Are you still on it?" is answered by the browser's own hit test
        (elementFromPoint), never by our own rectangle math. Layout is fractional
        and hit-testing is pixel-snapped: the two disagree on the edge pixel of
        every row, and a slow hand enters through exactly that pixel. v3 cleared
        the queued swap there and then went deaf.
     4. Every tier re-arms on every mousemove. A queued action can be cancelled for
        any reason; it must never STAY cancelled while the pointer is still on the
        thing that queued it. mouseover fires once per element change — it is the
        fast path, not the only path.
     5. "Inside the menu" is geometry, not DOM containment: the tile band (tiles AND
        the gaps between them) plus the open panel. Crossing a 10px gap slowly used
        to fire mouseleave -> close -> cold reopen on the next tile.

   v5 — THE THEME WAS STILL IN THE ROOM
     6. Wokiee's own menu script (theme.min.js, $(document).on('mouseenter mouseleave',
        '.tt-desctop-menu li')) runs on every tile we cross. Its mouseleave does
        fadeOut(0) + removeAttr('style') on the tile's dropdown — wiping our inline display,
        left and width. Cutting diagonally from a tile to the cards crosses the 10px gap to the
        next tile, so the open panel vanished for a frame, the safe triangle lost its target, and
        the next tile won instantly (the "swipe still switches to Gearboxes" bug, 12/12 runs on
        the aug-2026-updates preview). We now stop mouseover/mouseout at the icon row, which is
        all jQuery's delegated mouseenter/mouseleave listen to, and route our own tiers from
        there. A style watcher puts our display back if anything else ever rewrites it.
     7. Tier 1 judges "heading for the panel" over the last ~14px of travel, not only the last
        90ms, so a slow diagonal is protected exactly like a fast one. Stopping on a tile still
        opens it straight away (REST_MS).
     8. Card pictures start loading before you look: on approach to the icon row, when a row
        or link is queued, and (low priority) once the page is idle. They were lazy inside
        hidden panels, so they only started on open and then queued behind the rest of the page.

   Everything keys off .wcp-mega, our own class — no dependency on the theme's
   .ttmainmenuicons / li.megamenu naming.

   The product-card hover is CSS-only and is untouched by this file.
   ========================================================================== */

(function () {

  /* ---- tunables — everything you'd want to change lives here -------------- */
  var OPEN_DELAY   = 90;   // first open: prove you meant it
  var WARM_DELAY   = 0;    // switching while already open: free
  var CLOSE_DELAY  = 240;  // grace after you leave, before it starts closing
  var SWAP_DELAY   = 60;   // rail (2nd tier) settle
  var SWAP_FEAT    = 70;   // collection link (3rd tier) settle
  var MAX_HOLD     = 700;  // hard cap on how long the triangle may hold a swap
  var TRAIL_MS     = 90;   // how far back the triangle's apex sits
  var MIN_TRAVEL   = 7;    // px of real travel before "you're heading there" counts
  var MORPH_MS     = 260;  // keep in sync with .wcp-morph in the snippet CSS
  var FADE_MS      = 150;  // warm handover crossfade — keep in sync with .wcp-mega transition
  var VIEW_GAP     = 16;   // px kept clear between the panel's bottom and the window's bottom
  var DETAIL_PAD_B = 20;   // .wcp-detail bottom padding — keep in sync with the CSS
  var MIN_PANEL_H  = 260;  // never squash the panel below this, however short the window
  var MIN_SCROLL_H = 140;  // ...nor a links list / card box below this
  var DIST_APEX    = 14;   // v5: tier-1 heading is judged over this many px of travel...
  var REST_MS      = 120;  // ...while the pointer moved within this many ms (stopped = commit)
  var TRAIL_KEEP   = 400;  // ms of pointer history kept (slow hands need more than 240)
  var MAX_HOLD_TILE = 4000; // tier 1 holds while you keep heading down (a slow hand crossing a
                            // tile's corner can take 3-4 s); stopping still commits after REST_MS

  var PAGE_WIDE     = true;   // false -> panels sit under their own tile (old behavior)
  var SAFE_TRIANGLE = true;   // false -> plain timers everywhere
  var ALIGN_TO      = '';     // '' -> line up with the icon row itself (the <ul>), which always
                              // exists. Or name a wrapper, e.g. '.container', to align to that.
  var WCP_DEBUG     = false;  // true -> console.log what it found. Flip this first if it misbehaves.
  var FENCE_THEME   = true;   // v5: keep Wokiee's own menu hover script out of the icon row
  var WARM_IMAGES   = true;   // v5: start card pictures before the panel opens. Set again in boot() from
                              // body.wcp-nowarm (the theme setting "Load menu pictures before the menu opens" = off),
                              // because this file is loaded in <head>, where document.body does not exist yet.

  var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function log() { if (WCP_DEBUG && window.console) console.log.apply(console, ['[wcp-mega]'].concat([].slice.call(arguments))); }
  function now() { return +new Date(); }

  var teardown = null;                                    // undoes the previous boot's document listeners

  function boot() {
    if (teardown) { teardown(); teardown = null; }         // re-boot must not stack listeners
    WARM_IMAGES = !/\bwcp-nowarm\b/.test(document.body ? document.body.className : '');   // v5: the theme setting
    var bound = [];
    function on(target, type, fn, opts) { target.addEventListener(type, fn, opts); bound.push([target, type, fn, opts]); }
    teardown = function () { bound.forEach(function (b) { b[0].removeEventListener(b[1], b[2], b[3]); }); bound = []; };

    /* ---------------------------------------------------------------------
       DISCOVERY — find the panels first, then work outward to their <li>.
       Never depends on the theme's class names.
       --------------------------------------------------------------------- */
    var panels = [].slice.call(document.querySelectorAll('.wcp-mega'));
    if (!panels.length) { log('no .wcp-mega panels found — is the snippet installed?'); return; }

    var items = [];   // { li, panel }
    panels.forEach(function (p) {
      var li = p.closest ? p.closest('li') : null;
      if (li) items.push({ li: li, panel: p });
    });
    if (!items.length) { log('found panels but no parent <li>'); return; }

    var menuUl = items[0].li.parentNode;
    log('panels:', items.length, 'menu ul:', menuUl);
    if (WCP_DEBUG) {                                       // is the theme flattening the rail items?
      var probe = document.querySelector('.wcp-rail-item');
      if (probe) {
        var pcs = window.getComputedStyle(probe);
        log('rail item computed — radius:', pcs.borderRadius, '| margin:', pcs.margin,
            '| padding:', pcs.padding, '| display:', pcs.display,
            '(want 8px / 2px 7px / 11px 12px / flex — anything else is the theme overriding)');
      }
    }

    var openItem = null;                                  // the { li, panel } currently open
    var closeT = null, hideT = null;

    /* =====================================================================
       DISPLAY OWNERSHIP
       Inline + !important beats any stylesheet, so the theme's :hover rule
       can no longer show or hide a panel behind us. Set the resting state
       once at boot; from here on only show()/hide() move it.
       ===================================================================== */
    function hide(panel) {
      panel.style.setProperty('display', 'none', 'important');
      panel.style.removeProperty('visibility');
      panel.style.removeProperty('pointer-events');
      panel.style.opacity = '';
      panel.classList.remove('wcp-morph');
      panel.style.height = '';
      clearTimeout(panel.wcpMorphT);
    }
    function show(panel) {
      panel.style.setProperty('display', 'block', 'important');
      panel.style.setProperty('visibility', 'visible', 'important');
      panel.style.setProperty('pointer-events', 'auto', 'important');
    }
    /* Hand display back to the theme entirely. Inline !important is the only thing a
       stylesheet can't undo — including the theme's own mobile @media rules — so when the
       desktop menu isn't the active one we must let go rather than pin it shut forever. */
    function release(panel) {
      panel.style.removeProperty('display');
      panel.style.removeProperty('visibility');
      panel.style.removeProperty('pointer-events');
      panel.style.removeProperty('left');
      panel.style.removeProperty('width');
      panel.style.removeProperty('right');
      panel.style.removeProperty('margin');
      panel.style.removeProperty('min-width');
      panel.style.removeProperty('max-width');
      panel.style.removeProperty('transform');
      panel.style.opacity = '';
      panel.style.height = '';
      var inner = panel.querySelector('.wcp-mega-inner');
      if (inner) inner.style.maxHeight = '';
    }
    function desktopActive() {
      if (!menuUl) return false;
      // On a touch-only device there is no hover to drive any of this, and taking display
      // ownership would leave the menu unopenable. Leave it exactly as the theme had it.
      if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return false;
      var cs = window.getComputedStyle(menuUl);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && menuUl.getBoundingClientRect().width > 0;
    }
    var owned = false, escBlock = null;
    function takeOwnership() {
      var want = desktopActive();
      if (want === owned) return;
      owned = want;
      items.forEach(function (it) {
        if (owned) { if (openItem !== it) hide(it.panel); }
        else { it.li.classList.remove('wcp-open', 'wcp-warm', 'wcp-closing'); release(it.panel); }
      });
      if (!owned) { openItem = null; clearPending(); }
      log('display ownership:', owned ? 'ours (desktop)' : 'released to the theme (mobile)');
    }
    takeOwnership();                                      // resting state: we decide, not :hover

    /* =====================================================================
       PAGE-WIDE PANEL
       Wokiee anchors each dropdown under its own <li>, which is why the box
       slides sideways as you move along the bar. We move no DOM — we just give
       every panel the same left/width, measured off the icon row, so all of
       them land in the same place and read as one surface.
       ===================================================================== */
    function alignHost(li) {
      if (ALIGN_TO && li.closest) { var h = li.closest(ALIGN_TO); if (h) return h; }
      return menuUl;                                      // the icon row itself
    }
    function layoutWide(it) {
      if (!PAGE_WIDE) return;
      var host = alignHost(it.li); if (!host) return;
      var hr = host.getBoundingClientRect(); if (!hr.width) return;
      var cs = window.getComputedStyle(host);
      var padL = parseFloat(cs.paddingLeft) || 0, padR = parseFloat(cs.paddingRight) || 0;
      var op = it.panel.offsetParent || it.li;
      var or = op.getBoundingClientRect();
      var s = it.panel.style;
      /* No rounding: every panel must resolve to the SAME page position, and rounding each
         one against its own fractional origin drifts them ~1px apart — which is visible as
         a twitch on every category switch, the exact thing page-wide is meant to remove.
         clientLeft is the offsetParent's border, which left/top are measured inside of. */
      s.setProperty('left', (hr.left + padL - or.left - op.clientLeft) + 'px', 'important');
      s.setProperty('width', (hr.width - padL - padR) + 'px', 'important');
      s.setProperty('right', 'auto', 'important');
      s.setProperty('margin', '0', 'important');
      s.setProperty('min-width', '0', 'important');
      s.setProperty('max-width', 'none', 'important');
      s.setProperty('transform', 'none', 'important');    // in case the theme centres it with one
      log('layout', Math.round(hr.width), 'wide, host', host.className || host.tagName);
    }

    /* height morph — run `apply`, then animate old height -> new height.
       fromH lets one panel's height morph into another's on a category switch. */
    function morph(panel, fromH, apply) {
      if (!panel || reduced) { if (apply) apply(); return; }
      var from = (fromH != null) ? fromH : panel.offsetHeight;
      if (apply) apply();
      panel.classList.remove('wcp-morph');
      panel.style.height = '';
      var to = panel.offsetHeight;
      if (!from || !to || Math.abs(to - from) < 2) return;
      panel.style.height = from + 'px';
      panel.offsetHeight;                                 // flush, so the change is a transition
      panel.classList.add('wcp-morph');
      panel.style.height = to + 'px';
      clearTimeout(panel.wcpMorphT);
      panel.wcpMorphT = setTimeout(function () {
        panel.classList.remove('wcp-morph');
        panel.style.height = '';
      }, MORPH_MS + 40);
    }

    /* =====================================================================
       SAFE TRIANGLE v2
       A cursor heading for what it wants passes OVER everything in between.
       The apex sits ~90ms behind the cursor (not one sample), so the cone is
       a real cone; under MIN_TRAVEL px of movement it doesn't trigger at all.
       Re-checked continuously, so the instant you stop cutting across, the
       swap commits — no fixed penalty for having travelled.
       ===================================================================== */
    var trail = [];
    on(document, 'mousemove', function (e) {
      var t = now();
      trail.push({ x: e.clientX, y: e.clientY, t: t });
      while (trail.length > 2 && t - trail[0].t > TRAIL_KEEP) trail.shift();
      evaluate(false);                                    // re-decide any pending swap
      closeWatch();                                       // inside the menu? keep it open
      tileWatch();                                        // over another tile?
      panelWatch();                                       // over a rail row / link? (re-arms anything that got cleared)
      approachWatch();                                    // v5: heading for the icon row? warm its pictures
    }, { passive: true });

    /* The panel sits at top: calc(100% - 10px), i.e. it overlaps the bottom 10px of the
       tiles — and now that it's page-wide it overlaps the bottom of EVERY tile, not just
       its own. A pointer travelling along that strip is over the panel, so the other tiles
       never receive mouseenter and the category can't be switched from there. We already
       track the pointer, so resolve the tile geometrically instead of relying on the event. */
    function tileOf(it) { return it.li.querySelector('a') || it.li; }
    /* TIER-1 TARGET — the open panel, but with its top clamped to the bottom of the tile row.
       The panel sits at top:calc(100% - 10px), so its real top edge is 10px UP INSIDE the tile
       band. Aiming the cone at that edge switches the protection off while the cursor is still
       over a tile — which is exactly where a corner-cut ends, so the tile you happen to be over
       at that instant wins and the category swaps out from under you. The line that actually
       matters is where tiles stop being hoverable: the bottom of the row. */
    function panelEntry() {
      if (!openItem) return null;
      var r = openItem.panel.getBoundingClientRect();
      if (r.width) openItem.lastRect = { left: r.left, right: r.right, top: r.top, bottom: r.bottom };
      else if (openItem.lastRect) r = openItem.lastRect;  // v5: hidden for a frame -> aim where it was
      else return null;
      var top = Math.max(r.top, tilesBottom());
      var bottom = Math.max(r.bottom, top + 1);
      return { left: r.left, right: r.right, top: top, bottom: bottom, width: r.width, height: bottom - top };
    }
    function tileUnderPointer() {
      for (var i = 0; i < items.length; i++) { if (pointerOver(tileOf(items[i]), 1)) return items[i]; }
      return null;
    }
    function tilesBottom() {
      var b = 0;
      for (var i = 0; i < items.length; i++) { var r = tileOf(items[i]).getBoundingClientRect(); if (r.bottom > b) b = r.bottom; }
      return b || menuUl.getBoundingClientRect().bottom;
    }
    function tileWatch() {
      if (!owned) return;
      var it = tileUnderPointer();
      if (escBlock && it !== escBlock) escBlock = null;   // moved off it -> Esc suppression done
      if (!it || it === openItem || it === escBlock) return;
      var idx = items.indexOf(it);
      if (pending && pending.key === 'cat:' + idx) return;         // already queued
      cancelClose();
      queue('cat:' + idx, function () { return tileUnderPointer() === it; },
            panelEntry, 'y',
            openItem ? WARM_DELAY : OPEN_DELAY,
            function () { openIt(it); });
    }

    /* INSIDE THE MENU = the tile band (tiles + the gaps between them, down to where the
       panel starts) or the open panel itself. Geometry, not DOM containment: mouseleave
       fires in the 10px gap between two tiles, and a slow hand takes longer than
       CLOSE_DELAY to cross it — v3 closed the menu there and cold-reopened on the next
       tile. Re-evaluated on every move: inside cancels the close, outside arms it. */
    function insideMenu() {
      var p = lastPt(); if (!p) return false;
      var ur = menuUl.getBoundingClientRect(); if (!ur.width) return false;
      var pr = openItem ? openItem.panel.getBoundingClientRect() : null;
      var bandBottom = tilesBottom();
      if (pr && pr.width) bandBottom = Math.max(bandBottom, pr.top + 1);
      if (p.x >= ur.left - 1 && p.x <= ur.right + 1 && p.y >= ur.top - 1 && p.y <= bandBottom) return true;
      if (pr && pr.width && p.x >= pr.left - 1 && p.x <= pr.right + 1 && p.y >= pr.top - 1 && p.y <= pr.bottom + 1) return true;
      return false;
    }
    function closeWatch() {
      if (!owned || !openItem) return;
      if (insideMenu()) cancelClose();
      else if (!closeT && !hideT) scheduleClose();
    }

    function apex() {
      var t = now();
      for (var i = trail.length - 1; i >= 0; i--) { if (t - trail[i].t >= TRAIL_MS) return trail[i]; }
      return trail[0];
    }
    function sign(a, b, c) { return (a.x - c.x) * (b.y - c.y) - (b.x - c.x) * (a.y - c.y); }
    function inTri(p, a, b, c) {
      var d1 = sign(p, a, b), d2 = sign(p, b, c), d3 = sign(p, c, a);
      return !(((d1 < 0) || (d2 < 0) || (d3 < 0)) && ((d1 > 0) || (d2 > 0) || (d3 > 0)));
    }
    // is the cursor travelling toward the target's leading edge? axis 'x' = its left edge,
    // 'y' = its top edge. `target` may be an element or a plain rect (see the tier-1 target).
    function travelling(target, axis) {
      if (!SAFE_TRIANGLE || !target || trail.length < 2) return false;
      var p = trail[trail.length - 1], o = apex();
      if (!o) return false;
      var r = target.getBoundingClientRect ? target.getBoundingClientRect() : target;
      if (!r.width || !r.height) return false;
      var c1, c2;
      if (axis === 'x') {
        if (p.x >= r.left) return false;                  // already inside it — nothing to protect
        c1 = { x: r.left, y: r.top }; c2 = { x: r.left, y: r.bottom };
      } else {
        if (p.y >= r.top) return false;
        c1 = { x: r.left, y: r.top }; c2 = { x: r.right, y: r.top };
      }
      var moved = axis === 'x' ? (p.x - o.x) : (p.y - o.y);
      if (moved >= MIN_TRAVEL && inTri(p, o, c1, c2)) return true;
      /* v5 — TIER 1 ONLY. The 90ms apex needs ~80px/s of vertical speed to count, so an unhurried
         diagonal from a tile to the cards read as "resting on the next tile" and switched. Judge
         the heading over the last DIST_APEX px instead — speed no longer matters, direction does.
         Flat or upward (sliding along the row) still switches at once, and so does stopping. */
      if (axis !== 'y' || now() - p.t > REST_MS) return false;
      var d = apexByDistance(DIST_APEX);
      if (!d || p.y - d.y < 2) return false;
      return inTri(p, d, c1, c2);
    }
    // the newest trail point at least `minD` px behind the pointer (by straight-line distance)
    function apexByDistance(minD) {
      var p = trail[trail.length - 1];
      for (var i = trail.length - 2; i >= 0; i--) {
        if (Math.abs(p.x - trail[i].x) + Math.abs(p.y - trail[i].y) >= minD) return trail[i];
      }
      return null;
    }

    /* =====================================================================
       PENDING ACTION — one queue for all three tiers.
       An action waits while the triangle says you're travelling, then fires
       after its own settle delay. Re-evaluated on every move AND on a 40ms
       tick, so a cursor that simply stops still commits.
       ===================================================================== */
    var pending = null, tickT = null;
    function clearPending() { pending = null; clearTimeout(tickT); tickT = null; }
    function queue(key, over, target, axis, delay, run) {
      if (pending && pending.key === key) return;         // already pending this exact thing
      pending = { key: key, over: over, target: target, axis: axis, delay: delay, run: run, at: now(), freeAt: 0 };
      evaluate(true);                                     // skip the hover guard on the queuing event itself
    }
    function evaluate(fresh) {
      if (!pending) return;
      var n = now();
      // An action is only valid while you're still on the thing that queued it. Without this,
      // cutting diagonally across rail rows leaves the LAST row crossed pending, and it fires
      // the moment you arrive at the products — swapping the rail out from under you.
      if (!fresh && !pending.over()) { clearPending(); return; }
      var cap = pending.axis === 'y' ? MAX_HOLD_TILE : MAX_HOLD;   // v5: tiles may hold longer, see MAX_HOLD_TILE
      var held = travelling(pending.target(), pending.axis) && (n - pending.at < cap);
      if (held) { pending.freeAt = 0; tick(); return; }
      if (!pending.freeAt) pending.freeAt = n;
      if (n - pending.freeAt >= pending.delay) {
        var run = pending.run; clearPending(); run();
        return;
      }
      tick();
    }
    function tick() { clearTimeout(tickT); tickT = setTimeout(function () { evaluate(false); }, 40); }

    /* =====================================================================
       PANEL STATE
       ===================================================================== */
    function resetFeat(detail) {
      [].forEach.call(detail.querySelectorAll('.wcp-fgroup'), function (g) {
        g.classList.toggle('is-on', g.getAttribute('data-feat') === '0');
        g.classList.remove('wcp-fresh');
      });
      [].forEach.call(detail.querySelectorAll('.wcp-links a[data-feat]'), function (a) { a.classList.remove('wcp-active'); });
    }
    // reset a hidden panel for its next open: restore the LAST-used subcategory,
    // but reset that subcategory's featured back to its default product set.
    function resetMega(mega) {
      if (!mega) return;
      var saved = mega.getAttribute('data-wcp-rail') || '0';
      [].forEach.call(mega.querySelectorAll('.wcp-rail-item'), function (a) { a.classList.toggle('is-on', a.getAttribute('data-wcpidx') === saved); });
      [].forEach.call(mega.querySelectorAll('.wcp-detail'), function (d) {
        d.classList.remove('wcp-leaving', 'wcp-in-dn', 'wcp-in-up');
        d.classList.toggle('is-on', d.getAttribute('data-wcpidx') === saved);
        resetFeat(d);
      });
    }
    function freshen(group) {                             // re-trigger the card stagger
      if (!group || reduced) return;
      clearTimeout(group.wcpFreshT);
      group.classList.remove('wcp-fresh');
      group.offsetHeight;
      group.classList.add('wcp-fresh');
      /* ...and take it off once it's played (last card: .096s delay + .21s). Left on, the stagger
         REPLAYS whenever the cards are re-inserted or re-displayed — the theme's sticky header
         detaches the whole menu and re-appends it into the stuck bar — and replaying cards sit
         5px low, which a measurement taken right then mistakes for overflow. */
      group.wcpFreshT = setTimeout(function () { group.classList.remove('wcp-fresh'); }, 360);
    }

    // featured box shows up to TWO rows; one row -> natural height; more than two -> 2 rows + scroll.
    // Cards per row come off the live layout (5 wide, 4 below 1200px). `bottom` (viewport px) caps
    // it further so the panel never runs off-screen. offsetTop, not rects: the card stagger and the
    // detail crossfade both translate things, and a transform mustn't skew the measurement.
    // Measured live each time a group becomes visible (a hidden box has no measurable height).
    // Overflow is judged from that same layout (box.wcpFull), NOT scrollHeight: scrollHeight counts
    // transformed boxes, so cards mid-animation (translateY 5px) read as "more to scroll" when the
    // whole row actually fits — the "Scroll to view more" hint then shows with nothing below it.
    function ensureFeatScroll(group, bottom, keep) {
      if (!group) return;
      var box = group.querySelector('.wcp-fcards'); if (!box) return;
      var st = box.scrollTop;
      box.style.maxHeight = '';
      group.classList.remove('has-more', 'scrolled-end');
      var cards = [].filter.call(box.querySelectorAll('.wcp-fcard'), function (c) { return c.offsetParent; });
      if (!cards.length) return;
      var full = 0;                                       // the cards' real laid-out height, padding included
      for (var k = 0; k < cards.length; k++) full = Math.max(full, cards[k].offsetTop + cards[k].offsetHeight);
      full = box.wcpFull = full - box.offsetTop;
      var perRow = 0;
      while (perRow < cards.length && cards[perRow].offsetTop === cards[0].offsetTop) perRow++;
      var cap = Infinity;
      if (cards.length > perRow) {
        var rowsEnd = 0, n = Math.min(perRow * 2, cards.length);
        for (var i = 0; i < n; i++) rowsEnd = Math.max(rowsEnd, cards[i].offsetTop + cards[i].offsetHeight);
        cap = rowsEnd - box.offsetTop + (cards.length > perRow * 2 ? 22 : 2);
      }
      if (bottom) cap = Math.min(cap, Math.max(MIN_SCROLL_H, bottom - box.getBoundingClientRect().top));
      if (cap < full - 1) box.style.maxHeight = Math.floor(cap) + 'px';
      box.scrollTop = keep ? st : 0;
      if (full > box.clientHeight + 4) {
        group.classList.add('has-more');
        group.classList.toggle('scrolled-end', atEnd(box));
        if (!box.getAttribute('data-scroll-wired')) {
          box.setAttribute('data-scroll-wired', '1');
          box.addEventListener('scroll', function () { group.classList.toggle('scrolled-end', atEnd(box)); }, { passive: true });
        }
      }
    }
    function atEnd(box) {
      return box.scrollTop + box.clientHeight >= (box.wcpFull || box.scrollHeight) - 4;
    }

    /* FIT TO SCREEN — the panel hangs below the header, and a long subcategory (many L3 links,
       two card rows) on a 768–800px-tall laptop ran past the bottom of the window, where nothing
       could scroll to it. Cap everything to the room actually left on screen:
         - .wcp-mega-inner gets a max-height -> the rail (stretched to it) scrolls by itself
         - the live detail's L3 links and product cards each cap to the same bottom edge
       `keep` preserves scroll positions (resize / page scroll); a fresh open or swap starts at the top. */
    function fitPanel(panel, keep) {
      if (!panel) return;
      var inner = panel.querySelector('.wcp-mega-inner'); if (!inner) return;
      var pr = panel.getBoundingClientRect(); if (!pr.width) return;
      var border = parseFloat(window.getComputedStyle(panel).borderTopWidth) || 0;
      var room = Math.max(MIN_PANEL_H, window.innerHeight - VIEW_GAP - pr.top - border);
      inner.style.maxHeight = Math.floor(room) + 'px';
      var detail = panel.querySelector('.wcp-detail.is-on:not(.wcp-leaving)'); if (!detail) return;
      var bottom = pr.top + border + room - DETAIL_PAD_B;
      var links = detail.querySelector('.wcp-links');
      if (links) {                                        // always keeps its scroll: swapping products mustn't jump the list
        var lst = links.scrollTop;
        links.style.maxHeight = '';
        var lcap = Math.max(MIN_SCROLL_H, bottom - links.getBoundingClientRect().top);
        if (lcap < links.scrollHeight - 1) links.style.maxHeight = Math.floor(lcap) + 'px';
        links.scrollTop = lst;
      }
      ensureFeatScroll(detail.querySelector('.wcp-fgroup.is-on'), bottom, keep);
    }

    // "Scroll to view more" -> bring the next row of cards into view (one card + the row gap)
    on(document, 'click', function (e) {
      var btn = e.target.closest && e.target.closest('.wcp-mega .wcp-fmore-btn'); if (!btn) return;
      var group = btn.closest('.wcp-fgroup');
      var box = group && group.querySelector('.wcp-fcards'); if (!box) return;
      var card = box.querySelector('.wcp-fcard');
      var step = card ? card.offsetHeight + (parseFloat(window.getComputedStyle(box).rowGap) || 0) : box.clientHeight * 0.8;
      box.scrollBy({ top: step, behavior: reduced ? 'auto' : 'smooth' });
    });

    /* =====================================================================
       OPEN / CLOSE
       ===================================================================== */
    /* A close is only ever SCHEDULED here — openItem stays set until it actually happens.
       That matters: moving from category A to B fires A's mouseleave BEFORE B's mouseenter,
       so if the close nulled openItem straight away, B would always see "nothing open" and
       do a cold open — replaying the reveal on every single switch. */
    function cancelClose() {
      clearTimeout(closeT); closeT = null;
      clearTimeout(hideT); hideT = null;
      /* If we interrupted a close that had already started, openItem is null but a panel is
         still on screen and its hide timer has just been cancelled. Re-adopt it, or nothing
         owns it any more and it stays open forever. */
      if (!openItem) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].li.classList.contains('wcp-open')) { openItem = items[i]; break; }
        }
      }
      if (openItem) openItem.li.classList.remove('wcp-closing');   // re-entered mid-vanish -> snap back
    }
    function scheduleClose() {
      clearTimeout(closeT);
      closeT = setTimeout(function () { doClose(); }, CLOSE_DELAY);
    }
    function doClose() {
      var it = openItem; if (!it) return;
      openItem = null;
      clearPending();
      it.li.classList.add('wcp-closing');
      hideT = setTimeout(function () {
        it.li.classList.remove('wcp-open', 'wcp-closing', 'wcp-warm');
        hide(it.panel); resetMega(it.panel);
      }, reduced ? 0 : 130);
    }

    function openIt(it) {
      if (openItem === it) return;
      cancelClose();
      var prev = openItem, warm = !!prev, prevH = 0;

      /* Warm hand-over. The panels are identical in position, width and chrome, so
         swapping which one is displayed is invisible — the frame never blinks. Only the
         CONTENTS change (.wcp-mega-inner does a short settle-in, no clip-path reveal),
         and the height morphs from the outgoing panel's. Fading the whole panel here
         would fade its border + shadow too, which reads as the menu re-opening. */
      if (warm) {
        prevH = prev.panel.offsetHeight;
        prev.li.classList.remove('wcp-open', 'wcp-closing', 'wcp-warm');
        hide(prev.panel); resetMega(prev.panel);
      }

      items.forEach(function (o) {
        if (o === it || o === prev) return;
        o.li.classList.remove('wcp-open', 'wcp-closing', 'wcp-warm');
        hide(o.panel); resetMega(o.panel);
      });

      openItem = it;
      it.li.classList.remove('wcp-closing');
      it.li.classList.toggle('wcp-warm', warm);
      it.li.classList.add('wcp-open');
      show(it.panel);
      layoutWide(it);                                     // same tick -> never a frame at the old width
      // fit to the screen BEFORE morphing — it changes the panel's real height
      fitPanel(it.panel);
      if (warm && prevH) morph(it.panel, prevH, null);
      warmPanel(it);                                      // v5: this panel's pictures first
      markWaiting(shownGroup(it.panel));
    }

    items.forEach(function (it, idx) {
      on(it.li, 'mouseenter', function () {
        cancelClose();
        if (openItem === it) return;
        // TIER 1: diving diagonally out of the bar into the open panel -> ignore the tiles crossed.
        // The mouseenter is the fast path; tileWatch() re-queues this on the next move if it's cleared.
        queue('cat:' + idx, function () { return tileUnderPointer() === it || pointerOver(it.li, 1); },
              panelEntry, 'y',
              openItem ? WARM_DELAY : OPEN_DELAY,
              function () { openIt(it); });
      });

      on(it.li, 'mouseleave', function () {
        if (pending && pending.key === 'cat:' + idx) clearPending();   // flew over -> cancel
        /* Re-arm on leaving ANY tile, not just the open one. Entering a sibling cancels the
           open one's close; if you then leave that sibling before it commits, nothing would
           be left holding a timer and the panel would stay open forever. Re-entry cancels
           this again, so over-scheduling is free. */
        if (openItem) scheduleClose();
      });

      // keyboard parity — without this, taking ownership of display means Tab can't open it
      on(it.li, 'focusin', function () { cancelClose(); if (openItem !== it) openIt(it); });
      on(it.li, 'focusout', function (e) {
        if (!it.li.contains(e.relatedTarget) && openItem === it) scheduleClose();
      });
    });

    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape' || !openItem) return;
      escBlock = openItem;                                // don't let tileWatch re-open it under a still cursor
      clearTimeout(closeT);
      doClose();
    });

    /* =====================================================================
       TIER 2 — rail item -> its detail column
       ===================================================================== */
    /* Hard-normalise the crossfade: at most ONE detail is is-on, plus at most one
       still fading out. Every detail carries its own cleanup timer (d.wcpT) which is
       cleared before reuse — otherwise flicking through the rail fast leaves stale
       timers firing against panels that have since changed state, and you end up
       seeing two subcategories at once. */
    function clearDetail(d) {
      clearTimeout(d.wcpT);
      d.classList.remove('is-on', 'wcp-leaving', 'wcp-in-dn', 'wcp-in-up');
    }
    /* THE INVARIANT: exactly one detail is shown, and it is the committed one.
       Whatever races happen mid-crossfade, this runs once the transition window
       closes and forces the DOM back to a single panel. Nothing else may leave
       two subcategories on screen. */
    function assertOne(mega) {
      var want = mega.getAttribute('data-wcp-rail') || '0';
      [].forEach.call(mega.querySelectorAll('.wcp-detail'), function (d) {
        if (d.getAttribute('data-wcpidx') === want) {
          clearTimeout(d.wcpT);
          d.classList.remove('wcp-leaving', 'wcp-in-dn', 'wcp-in-up');
          d.classList.add('is-on');
        } else clearDetail(d);
      });
      [].forEach.call(mega.querySelectorAll('.wcp-rail-item'), function (a) {
        a.classList.toggle('is-on', a.getAttribute('data-wcpidx') === want);
      });
    }
    /* Is the pointer over this element? Answered from the last real mousemove position
       rather than :hover — deterministic, doesn't depend on a style recalc, and none of
       these elements are ever covered by another (the panel hangs BELOW the tiles).
       :hover is the fallback for before the mouse has moved at all. */
    function lastPt() { return trail.length ? trail[trail.length - 1] : null; }
    function pointerOver(el, slop) {
      if (!el) return false;
      var p = lastPt();
      if (p) {
        var r = el.getBoundingClientRect(), s = slop || 0;
        if (r.width && r.height) return p.x >= r.left - s && p.x <= r.right + s && p.y >= r.top - s && p.y <= r.bottom + s;
      }
      return !!(el.matches && el.matches(':hover'));
    }
    /* THE BROWSER'S ANSWER to "what is under the pointer" — the same hit test that
       decided which element got mouseover. Rect math is fractional (a row's top can be
       323.2) while hit-testing is pixel-snapped (pixel row 323 IS the row), so the two
       disagree on the edge pixel, and a slow hand enters through exactly that pixel. */
    function hitEl() {
      var p = lastPt(); if (!p) return null;
      var e = document.elementFromPoint(p.x, p.y);
      return (e && e.closest) ? e : null;
    }
    function hitAt(sel) { var e = hitEl(); return e ? e.closest(sel) : null; }
    // which rail item is under the cursor RIGHT NOW — the commit trusts this, not the
    // index that queued it, so what loads is always what you're actually hovering.
    function railUnderPointer(mega) {
      var a = hitAt('.wcp-mega .wcp-rail-item');
      return (a && a.closest('.wcp-mega') === mega) ? a.getAttribute('data-wcpidx') : null;
    }

    function switchDetail(mega, idx, dir) {
      var newD = mega.querySelector('.wcp-detail[data-wcpidx="' + idx + '"]');
      if (!newD) return;
      // the LIVE one — never a panel that's mid-fade-out, which still carries .is-on
      var oldD = mega.querySelector('.wcp-detail.is-on:not(.wcp-leaving)');

      if (oldD === newD) {                                // flicked back to where we already are
        [].forEach.call(mega.querySelectorAll('.wcp-detail'), function (d) { if (d !== newD) clearDetail(d); });
        clearTimeout(newD.wcpT);
        newD.classList.remove('wcp-leaving');
        return;
      }

      morph(mega, null, function () {
        // anything that isn't the outgoing or incoming panel goes away NOW
        [].forEach.call(mega.querySelectorAll('.wcp-detail'), function (d) {
          if (d !== newD && d !== oldD) clearDetail(d);
        });
        resetFeat(newD);
        if (reduced) {
          if (oldD) clearDetail(oldD);
          newD.classList.add('is-on');
        } else {
          if (oldD) {
            clearTimeout(oldD.wcpT);
            oldD.classList.remove('wcp-in-dn', 'wcp-in-up');
            oldD.classList.add('wcp-leaving');            // absolute + fade, so it can't inflate the height
            oldD.wcpT = setTimeout(function () { oldD.classList.remove('is-on', 'wcp-leaving'); }, 130);
          }
          clearTimeout(newD.wcpT);
          newD.classList.remove('wcp-leaving', 'wcp-in-dn', 'wcp-in-up');
          newD.classList.add('is-on', dir > 0 ? 'wcp-in-dn' : 'wcp-in-up');
          newD.wcpT = setTimeout(function () {
            newD.classList.remove('wcp-in-dn', 'wcp-in-up');
            assertOne(mega);                              // transition over -> exactly one panel
          }, 200);
        }
        [].forEach.call(mega.querySelectorAll('.wcp-rail-item'), function (a) { a.classList.toggle('is-on', a.getAttribute('data-wcpidx') === String(idx)); });
        mega.setAttribute('data-wcp-rail', idx);          // remember for the next open
        fitPanel(mega);                                   // inside apply: it changes the height
      });
      freshen(newD.querySelector('.wcp-fgroup.is-on'));
      markWaiting(newD.querySelector('.wcp-fgroup.is-on'));
    }

    /* v5 — FENCE. Wokiee binds $(document).on('mouseenter mouseleave', '.tt-desctop-menu li')
       and, on every mouseleave, fades the li's .dropdown-menu out and strips its style attribute
       (plus body / .tt-header-static styles). jQuery's delegated mouseenter/mouseleave are
       mouseover/mouseout bubbling up to document, so stopping those two at the icon row keeps the
       theme out of this menu entirely; our own routing listens here, below the stop. Released
       (no stop) whenever we don't own the menu — touch devices and mobile keep the theme's code. */
    on(menuUl, 'mouseover', function (e) {
      if (e.target && e.target.closest) route(e.target);
      if (FENCE_THEME && owned) e.stopPropagation();
    });
    on(menuUl, 'mouseout', function (e) { if (FENCE_THEME && owned) e.stopPropagation(); });
    /* Same routing off the tracked pointer. mouseover fires once per element change; if the
       queued action gets cleared while the pointer is still on the same element, nothing else
       would ever re-queue it — so every move asks again. Idempotent: queue() ignores a key
       that's already pending, and the is-on branches just clear. */
    function panelWatch() {
      if (!owned || !openItem) return;
      var e = hitEl(); if (!e) return;
      if (e.closest('.wcp-mega') !== openItem.panel) return;
      route(e);
    }
    function route(target) {
      var item = target.closest('.wcp-mega .wcp-rail-item');
      if (item) {
        if (item.classList.contains('is-on')) { if (pending && pending.key.indexOf('rail:') === 0) clearPending(); return; }
        var mega = item.closest('.wcp-mega'); if (!mega) return;
        var idx = item.getAttribute('data-wcpidx');
        var nd = mega.querySelector('.wcp-detail[data-wcpidx="' + idx + '"]');
        warm(nd && (nd.querySelector('.wcp-fgroup.is-on') || nd.querySelector('.wcp-fgroup')), 'high');
        queue('rail:' + idx, function () { return hitAt('.wcp-mega .wcp-rail-item') === item; },
              function () { return mega.querySelector('.wcp-detail-wrap'); }, 'x',
              SWAP_DELAY,
              function () {
                // commit to whatever is hovered AT THIS INSTANT — flicking through the rail
                // must never land you on a row you've already left
                var live = railUnderPointer(mega);
                if (live === null) return;                // left the rail entirely -> show nothing new
                var cur = mega.querySelector('.wcp-rail-item.is-on');
                var d = parseInt(live, 10) > parseInt(cur ? cur.getAttribute('data-wcpidx') : 0, 10) ? 1 : -1;
                switchDetail(mega, live, d);
              });
        return;
      }

      /* TIER 3 — collection link -> its products */
      var fl = target.closest('.wcp-mega .wcp-links a[data-feat]');
      if (fl) {
        var d1 = fl.closest('.wcp-detail'); if (!d1) return;
        queueFeat(function () { return hitAt('.wcp-mega .wcp-links a[data-feat]') === fl; }, d1, fl.getAttribute('data-feat'), fl);
        return;
      }
      // "Shop all <subcategory>" -> back to this subcategory's default set
      var foot = target.closest('.wcp-mega .wcp-foot a');
      if (foot) {
        var d2 = foot.closest('.wcp-detail'); if (!d2) return;
        queueFeat(function () { return hitAt('.wcp-mega .wcp-foot a') === foot; }, d2, '0', null);
        return;
      }
      // reached the products themselves -> freeze whatever's showing, so moving from a
      // link straight onto a card never changes the results out from under you
      if (target.closest('.wcp-mega .wcp-fcards, .wcp-mega .wcp-fmore-btn')) clearPending();
    }

    function swapFeat(detail, featIdx, link) {
      var mega = detail.closest('.wcp-mega');
      morph(mega, null, function () {
        [].forEach.call(detail.querySelectorAll('.wcp-fgroup'), function (g) { g.classList.toggle('is-on', g.getAttribute('data-feat') === featIdx); });
        if (mega) [].forEach.call(mega.querySelectorAll('.wcp-links a.wcp-active'), function (a) { a.classList.remove('wcp-active'); });
        if (link) link.classList.add('wcp-active');       // link colours only as its products appear
        fitPanel(mega);                                   // inside apply: it changes the height
      });
      freshen(detail.querySelector('.wcp-fgroup.is-on'));
      markWaiting(detail.querySelector('.wcp-fgroup.is-on'));
    }
    function queueFeat(over, detail, featIdx, link) {
      var cur = detail.querySelector('.wcp-fgroup.is-on');
      if (cur && cur.getAttribute('data-feat') === featIdx) { if (pending && pending.key.indexOf('feat:') === 0) clearPending(); return; }
      warm(detail.querySelector('.wcp-fgroup[data-feat="' + featIdx + '"]'), 'high');
      queue('feat:' + detail.getAttribute('data-wcpidx') + ':' + featIdx, over,
            function () { return detail.querySelector('.wcp-feat'); }, 'x',
            SWAP_FEAT,
            function () { swapFeat(detail, featIdx, link); });
    }

    /* keep the page-wide panel honest on resize */
    var rzT = null;
    on(window, 'resize', function () {
      clearTimeout(rzT);
      rzT = setTimeout(function () {
        takeOwnership();                                  // crossing the mobile breakpoint hands control back
        if (owned && openItem) { layoutWide(openItem); fitPanel(openItem.panel, true); }
      }, 120);
    }, { passive: true });

    /* scrolling the page moves the header (or sticks it), which changes the room below the
       panel — re-fit once per frame while a panel is open */
    var fitRaf = 0;
    on(window, 'scroll', function () {
      if (!owned || !openItem || fitRaf) return;
      fitRaf = requestAnimationFrame(function () { fitRaf = 0; if (openItem) fitPanel(openItem.panel, true); });
    }, { passive: true });

    /* =====================================================================
       OWNERSHIP GUARD (v5) — the fence keeps the theme's hover script out, but anything else that
       rewrites a panel's style attribute (an app, a theme update) would silently take display
       back. While we own the menu, put back what we set. A MutationObserver runs as a microtask,
       i.e. before the browser paints, so a stripped panel never shows a missing frame.
       ===================================================================== */
    var guarding = false;
    var guard = window.MutationObserver ? new MutationObserver(function () {
      if (!owned || guarding) return;
      guarding = true;
      items.forEach(function (it) {
        var open = it.li.classList.contains('wcp-open');  // includes a panel mid-close
        var s = it.panel.style, want = open ? 'block' : 'none';
        if (s.getPropertyValue('display') === want && s.getPropertyPriority('display') === 'important') return;
        log('panel style rewritten from outside — restoring', it.li);
        if (open) { show(it.panel); layoutWide(it); fitPanel(it.panel, true); } else hide(it.panel);
      });
      guarding = false;
    }) : null;
    if (guard) {
      items.forEach(function (it) { guard.observe(it.panel, { attributes: true, attributeFilter: ['style'] }); });
      var unbind = teardown;
      teardown = function () { guard.disconnect(); unbind(); };
    }

    /* =====================================================================
       PICTURES READY BEFORE YOU LOOK (v5)
       Card pictures are loading="lazy" inside display:none panels, so the browser starts them only
       when a panel opens; on a busy connection they then wait behind whatever the page is still
       downloading (aug-2026-updates preview, 5 Mbps: ~8 s for the first row). Start them earlier:
         - the pointer comes within reach of the icon row -> the tile under it, high priority
         - a panel opens / a rail row or link is queued  -> that row, high; the panel's other rows, low
         - the page has loaded and gone idle              -> every tile's first row, low
           (skipped on Save-Data / 2G)
       Warming = flipping loading="lazy" to "eager" on the same <img>, so the browser fetches the
       exact srcset candidate it will paint. Nothing downloads twice, nothing is added to the page.
       ===================================================================== */
    var conn = navigator.connection || {};
    var lite = !!conn.saveData || /2g$/.test(conn.effectiveType || '');
    function warm(scope, prio) {
      if (!WARM_IMAGES || !scope) return;
      var imgs = scope.querySelectorAll('img[loading="lazy"]');
      for (var i = 0; i < imgs.length; i++) {
        if (prio) imgs[i].setAttribute('fetchpriority', prio);
        imgs[i].loading = 'eager';
      }
    }
    function shownGroup(panel) {
      return panel.querySelector('.wcp-detail.is-on:not(.wcp-leaving) .wcp-fgroup.is-on') ||
             panel.querySelector('.wcp-detail .wcp-fgroup');
    }
    function warmPanel(it) {
      warm(shownGroup(it.panel), 'high');
      [].forEach.call(it.panel.querySelectorAll('.wcp-detail'), function (d) {
        warm(d.querySelector('.wcp-fgroup[data-feat="0"]'), 'low');
      });
    }
    function approachWatch() {
      if (!owned || openItem || lite) return;
      var p = lastPt(); if (!p) return;
      var ur = menuUl.getBoundingClientRect(); if (!ur.width) return;
      if (p.x < ur.left || p.x > ur.right || p.y < ur.top - 120 || p.y > ur.bottom + 40) return;
      var best = null, bd = Infinity;                     // the tile nearest the pointer's x
      for (var i = 0; i < items.length; i++) {
        var r = tileOf(items[i]).getBoundingClientRect(), dx = Math.abs((r.left + r.right) / 2 - p.x);
        if (dx < bd) { bd = dx; best = items[i]; }
      }
      if (best && !best.warmed) { best.warmed = true; warm(shownGroup(best.panel), 'high'); }
    }
    function warmAllWhenIdle() {
      if (lite) return;
      var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
      idle(function () { items.forEach(function (it) { warm(shownGroup(it.panel), 'low'); }); }, { timeout: 4000 });
    }
    if (document.readyState === 'complete') warmAllWhenIdle(); else on(window, 'load', warmAllWhenIdle);

    /* a picture that still isn't here when its cards show gets a soft placeholder, then fades in */
    function markWaiting(group) {
      if (!group) return;
      [].forEach.call(group.querySelectorAll('.wcp-fimg img'), function (img) {
        if (img.complete && img.naturalWidth) return;
        var box = img.parentNode; box.classList.add('wcp-wait');
        var done = function () { box.classList.remove('wcp-wait'); img.removeEventListener('load', done); img.removeEventListener('error', done); };
        img.addEventListener('load', done); img.addEventListener('error', done);
      });
    }

    watchForRerender(panels);
    log('ready');
  }

  /* Shopify re-renders a section's markup in the theme editor (and some apps swap the
     header at runtime). That replaces the <li>s, taking our listeners and our inline
     display ownership with them — the theme's :hover would silently take the menu back.
     Watch for panels we don't know about and re-boot. childList only, so our own inline
     style writes can't feed the observer. */
  var knownPanels = [], rerenderObs = null;
  function watchForRerender(known) {
    knownPanels = known;
    if (rerenderObs || !window.MutationObserver) return;   // ONE observer for the page's lifetime
    var t = null;
    /* Still watches <body>: the theme moves the icon menu between sections at runtime (into the
       header, and into the sticky bar), so no single section is a safe root. But cart drawers,
       sliders and app widgets mutate the page constantly — so bail out unless a mutation actually
       ADDED mega-menu markup, instead of re-querying the whole document on every one. */
    function addsMega(records) {
      for (var r = 0; r < records.length; r++) {
        var added = records[r].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType === 1 && (node.classList.contains('wcp-mega') || node.querySelector('.wcp-mega'))) return true;
        }
      }
      return false;
    }
    rerenderObs = new MutationObserver(function (records) {
      if (!addsMega(records)) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var live = document.querySelectorAll('.wcp-mega');
        for (var i = 0; i < live.length; i++) {
          if (knownPanels.indexOf(live[i]) === -1) { log('markup re-rendered — re-booting'); boot(); return; }
        }
      }, 150);
    });
    rerenderObs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

})();